/* unplugin-vue-components disabled */import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import { mapState } from 'vuex';
import BottomBar from './subPages/BottomBar';
export default {
  components: {
    ViewBox: ViewBox,
    BottomBar: BottomBar
  },
  data: function data() {
    return {
      transitionName: '',
      vueTouches: {
        x: '',
        y: ''
      },
      startPosition: '',
      endPosition: ''
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['isInMain', 'showHomebottomBar', 'keepAliveList', 'RUN_ENV'])),
  watch: {
    $route: function $route(to, from) {
      if (!(['Home', 'Project', 'Mine'].indexOf(to.name) !== -1 && ['Home', 'Project', 'Mine'].indexOf(from.name) !== -1)) {
        var toDepth = to.path.split('/').length;
        var fromDepth = from.path.split('/').length;
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      } else {
        this.transitionName = '';
      }
    }
  },
  methods: {
    // 开始滑动
    touchstart: function touchstart(e) {
      if (!this.isInMain) {
        this.vueTouches = {
          x: e.changedTouches[0].pageX,
          y: e.changedTouches[0].pageY
        };
      }
    },
    // 滑动事件 - 滑动结束
    touchend: function touchend(e) {
      // if (!this.isInMain) {
      //   let disX = e.changedTouches[0].pageX - this.vueTouches.x  // 计算移动的位移差
      //   let disY = e.changedTouches[0].pageY - this.vueTouches.y
      //   if (Math.abs(disX) > 50 || Math.abs(disY) > 100) {
      //     if (disX > 100) {
      //       this.$router.go(-1)
      //     }
      //   }
      // }
    },
    // 阻止默认滑动事件
    touchFalse: function touchFalse(e) {
      if (!this.isInMain) {
        // e.preventDefault()
      }
    }
  },
  mounted: function mounted() {
    var loadingMask = document.getElementById('loadingDiv');
    if (loadingMask) loadingMask.parentNode.removeChild(loadingMask);

    // if (this.$DingTalk) {
    //   // 隐藏右上角按钮
    //   this.$DingTalk.biz.navigation.setRight({
    //     show: false
    //   })
    //   // 禁用下拉刷新
    //   this.$DingTalk.ui.pullToRefresh.disable()
    //   // 禁用bounce
    //   this.$DingTalk.ui.webViewBounce.disable()
    // }
    if (this.RUN_ENV === 'Android') {
      this.$setBackbuttonListen();
    }
  }
};